import styles from "css/auction/NftGridItem.module.css";

type Props = {
  children: any;
};

export default function NftGridItem({ children }: Props) {
  return <div className={styles.item}>{children}</div>;
}
